@if (anyEnabledTaskSearches$ | async) {
  <section id="tasks">
    <div class="sidebar-group mat-elevation-z1">
      <mat-icon>tasks</mat-icon>
      <span transloco="TASKS"></span>
      <span class="spacer"></span>
      <app-navigation-expansion-button
        [isExpanded]="(isExpanded$ | async)!"
        (isExpandedChange)="onExpandChanged()"
      ></app-navigation-expansion-button>
    </div>
    @if (isTaskSearchesLoading$ | async) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
    @if (isExpanded$ | async) {
      <div id="task-items">
        @for (taskSearch of taskSearches$ | async; track taskSearch) {
          <app-navigation-task-search
            [dbId]="(databaseId$ | async)!"
            [taskSearch]="taskSearch"
          ></app-navigation-task-search>
        }
      </div>
    }
  </section>
}
